import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "soundbar",
  templateUrl: "./soundBar.component.html",
  styleUrls: ["./soundBar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoundBarComponent {
  slots = [0, 0, 0, 0, 0, 0, 0, 0];

  indicatorLayer;

  constructor(
    private ref: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  /**
   * Starting the component
   * @retrun void
   */
  ngOnInit() {
    let width = parseInt(getComputedStyle(this.ref.nativeElement).width);
    let numberOfElements = parseInt(width / 2 + "");

    this.slots = Array(numberOfElements).fill(0);

    this.indicatorLayer = this.ref.nativeElement.querySelector("i");

    setInterval(() => {
      this.indicatorLayer.style.width = Math.round(Math.random() * 100) + "%";
      this.changeDetectorRef.markForCheck();
    }, 200);
  }
}
